import WebComponent from 'webcomponent';

import {registerMPElement} from '../../util/register-element';
import {truncateToElement} from '../../util';
import throttle from 'lodash/throttle';

const activeElems = new Set();
const updateElems = throttle(() => activeElems.forEach((elem) => elem.updateText()), 200);
setInterval(updateElems, 500);
window.addEventListener(`resize`, updateElems);

export default registerMPElement(
  `mp-truncated-text`,
  class extends WebComponent {
    static get observedAttributes() {
      return [`min-width`, `title`];
    }

    updateText(force) {
      const newWidth = this.clientWidth;
      if (!force && this.width === newWidth) {
        return;
      }
      this.width = Math.max(this.minWidth, newWidth);
      this.innerText = truncateToElement(this.getAttribute(`title`), this, {minWidth: this.minWidth});
    }

    attributeChangedCallback() {
      if (!this.initialized) {
        return;
      }
      this.updateText(true);
    }

    connectedCallback() {
      this.initialized = true;
      this.updateText(true);
      activeElems.add(this);
    }

    disconnectedCallback() {
      activeElems.delete(this);
    }

    get minWidth() {
      const minWidth = parseInt(this.getAttribute(`min-width`));
      return Number.isInteger(minWidth) ? minWidth : 0;
    }
  },
);
